import { Media } from '@/payload-types'

export const getMediaUrl = (media: Media | string | undefined | null) => {
  if (!media) return ''
  if (typeof media === 'string') {
    return media
  }
  return media.url || ''
}
